/**
 * Shared MemoEditModal - extracted from TaigaSheetDetailPage.tsx.
 * Used by both TaigaSheetDetailPage and TaigaMentionsSection for editing session memos.
 */
import type { FC } from "react"
import { useState } from "react"

import { useIsMobile } from "./CreateSessionModal"

import styles from "../TaigaSheetDetailPage.module.scss"

const MemoEditModal: FC<{
	nodeId: string
	nodeName: string
	currentMemo: string | null
	onClose: () => void
	onSubmit: (nodeId: string, memo: string | null) => void
	isLoading: boolean
}> = ({ nodeId, nodeName, currentMemo, onClose, onSubmit, isLoading }) => {
	const [memo, setMemo] = useState(currentMemo ?? "")
	const isMobile = useIsMobile()

	return (
		<div className={styles.modalOverlay} onClick={onClose}>
			<div className={styles.modal} onClick={(e) => e.stopPropagation()}>
				<h3 className={styles.modalTitle}>メモ - {nodeName}</h3>
				<div className={styles.modalField}>
					<textarea
						className={styles.promptInput}
						placeholder="メモを入力..."
						value={memo}
						onChange={(e) => setMemo(e.target.value)}
						onKeyDown={(e) => {
							if (
								e.key === "Enter" &&
								(isMobile || e.metaKey || e.ctrlKey) &&
								!e.nativeEvent.isComposing &&
								!isLoading
							) {
								e.preventDefault()
								onSubmit(nodeId, memo.trim() || null)
							}
							if (e.key === "Escape") {
								e.preventDefault()
								onClose()
							}
						}}
						maxLength={2000}
						rows={5}
						autoFocus
					/>
					<span
						className={`${styles.memoCharCount} ${memo.length >= 1800 ? styles.memoCharCountWarn : ""}`}
					>
						{memo.length}/2000
					</span>
				</div>
				<div className={styles.modalActions}>
					<button
						className={styles.cancelBtn}
						onClick={onClose}
						disabled={isLoading}
					>
						キャンセル
					</button>
					<button
						className={styles.createBtn}
						onClick={() => onSubmit(nodeId, memo.trim() || null)}
						disabled={isLoading}
					>
						{isLoading ? "保存中..." : "保存 (⌘+Enter)"}
					</button>
				</div>
			</div>
		</div>
	)
}

export default MemoEditModal
